import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { paths } from '../../../../../../common/constants/pathVariables.js';
import { SubscriptionCategory } from '../../../../../../common/enums.js';
import {
  employeeDevicesSubtitleMsg,
  myDevicesAndSubscriptionsMsg,
  myDevicesMsg,
  omaElisaForEmployeeMsg,
  t,
} from '../../../../../../common/i18n/index.js';
import { EoeDeviceSubscriptions } from '../../../../../../components/EoeSubscriptions/EoeDeviceSubscriptions.js';
import { EoeSubscriptionsLayout } from '../../../../../../components/EoeSubscriptions/EoeSubscriptionsLayout.js';
import { getEmployeeSubscriptions, loadVirtualCatalogs } from '../../../../../../selfservice/actions/index.js';
import { useAuth } from '../../../../AuthProvider.js';

export const EoeDevicesPath = () => {
  const dispatch = useDispatch();
  const { authenticatedUser } = useAuth();

  useEffect(() => {
    if (authenticatedUser?.businessId) {
      dispatch(loadVirtualCatalogs());
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.DEVICE));
    }
  }, [dispatch, authenticatedUser?.businessId]);

  return (
    <EoeSubscriptionsLayout
      breadCrumbs={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.YRZJ(myDevicesAndSubscriptionsMsg), path: paths.EMPLOYEE_DEVICES },
        { name: t.NP53(myDevicesMsg) },
      ]}
      title={t.NP53(myDevicesMsg)}
      subtitle={t.AE4T(employeeDevicesSubtitleMsg)}
    >
      <EoeDeviceSubscriptions />
    </EoeSubscriptionsLayout>
  );
};
